import React from "react";
import Markdown from "react-markdown";

export default function DataLinkages({
  data_linkage_desc,
  data_linkage_types,
}: {
  data_linkage_desc?: string;
  data_linkage_types?: string;
}) {
  let parsedDataLinkageTypes: Record<string, string> | undefined;

  try {
    if (data_linkage_types) {
      parsedDataLinkageTypes = JSON.parse(data_linkage_types);
    }
  } catch (error) {
    console.error("Failed to parse data_linkage_types:", error);
  }

  return (
    <div className="tab-pane fade show active">
      {data_linkage_desc && (
        <div className="g2-text-grey">
          <Markdown>{data_linkage_desc}</Markdown>
        </div>
      )}
      {parsedDataLinkageTypes && (
        <table className="table table-hover table-striped" width="100%">
          <tbody>
            {Object.entries(parsedDataLinkageTypes).map(([field, value], index) => (
              <tr key={index}>
                <td width="50%" className="fw-bold text-end">
                  {field}
                </td>
                <td width="50%">{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
